import React, { useState, useEffect } from 'react';
import CardProfile from '../../../components/Profile/Card/';

import ButtonBase from '../../../components/Buttons/ButtonBase';
import AuthButton from '../../../components/Buttons/AuthButton';
import ButtonAction from '../../../components/Buttons/ButtonAction';
import OptionsButton from '../../../components/Buttons/OptionsButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { makeStyles } from '@material-ui/styles';
import './Picture.scss';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { setimgViews, deleteimgViews } from '../../../store/actions/UserAction';
import { openModalFree } from '../../../store/actions/ModalFree';
// import { deleteimgViews } from '../../../store/actions/UserAction';
import {
  storage,
  firestore,
} from '../../../configs/environments/firebase/firebaseApp';
import { connect } from 'react-redux';
import Snackbar from '../../../components/Snackbar';
import TrophieModal from '../../../components/Modal/TrophieModal';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles(theme => ({
  modal: {
    background: 'rgba( 1, 57, 87, 0.7)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '999999999999 !important',
  },

  cardHeader: {
    display: 'block',
    paddingBottom: 0,
    fontSize: 22,
    '&:after': {
      content: '""',
      display: 'block',
      margin: '0 auto',
      width: '100%',
      paddingTop: '8px',
      borderBottom: '1px solid #c1c1c1',
    },
  },
  photos: {
    objectFit: 'cover',
  },
  inputFile: {
    height: 96,
    display: 'none',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const Picture = props => {
  const {
    trash,
    imgViews,
    uid,
    setimgViews,
    deleteimgViews,
    authClient,
    showLoading,
    hideLoading,
    membershipType,
    trophiePic,
    openModalFree
  } = props;

  const [flagSaved, setFlagSaved] = useState(false);

  const [image, setImage] = useState(null);

  const [url, setUrl] = useState();

  //const [indexZoom, setIndexZoom] = useState(0);

  const [picturElem, setPicturElem] = useState([]);

  const [open, setOpen] = useState(false);

  const [modal_image, setModalImage] = useState();

  const [ openTrophieModal, setOpenTrophieModal ] = useState(false);
  const [ alreadyRewarded, setAlreadyRewarded ] = useState(false);

  const handleOpenTrophieModal = () => {
    if (!alreadyRewarded) {
      setOpenTrophieModal(true);
      setAlreadyRewarded(true)
    }
  };

  const handleCloseTrophieModal = () => {
    setOpenTrophieModal(false);
  };

  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };

  /* 
  const [picturZoomElem, setPicturZoomElem] = useState([
    'https://i.imgur.com/fsyrScY.jpg',
  ]);
 */
  /*   const handleSubmit = (values, { setSubmitting, setFieldError }) => {
      setSubmitting(false);
    }; */

  /*   const formValues = {
      specialties: [],
    }; */

  const classes = useStyles();

  function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = []; 

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  const AddImage = NewImage => {
    let nElements = picturElem.length ? picturElem.length + 1 : 0;

    let dataArray = {
      src: NewImage,
    };

    setPicturElem(picturElem => {
      return [...picturElem, dataArray]
    }
    );    
  };

  let membershipLimit = 7

  const handleChange = e => {

    const { files } = e.target;
    if (picturElem.length < membershipLimit) {
      let src;
      const fsize = files[0].size;
      const filesizeTotal = Math.round(fsize / 1024);

      if (filesizeTotal >= 4096) {
        alert('Imagen mayor a 4MB porfavor ingrese una de menor peso');
      } else {
        let reader = new FileReader();
        reader.onload = function () {
          fireUpload(reader.result)
        };
        
        reader.readAsDataURL(files[0]);
        setImage(reader);
        setUrl(reader);
        setFlagSaved(true);
      }
    }
    
  };

  const fireUpload = (item ) => {
    let dataSplit = item.split(',')[1]
    showLoading()

    var metadata = {
      contentType: 'image/jpeg',
    };

    if (dataSplit) {
      var base64result = dataSplit;
      var imageBlod = b64toBlob(base64result);
      let index = picturElem.length === 0 ? 0 : picturElem.length + 1
      let sPhoto = `CAP_${index}_${Math.floor(Math.random() * 100)}`;
      
      
      const uploadTask = storage
        .ref(`profileImage/${uid}/imgView/${sPhoto}`)
        .put(imageBlod, metadata);
      uploadTask.on(
        'state_changed',
        snapShot => {
        },
        err => {},
        () => {
          storage
            .ref(`profileImage/${uid}/imgView/`)
            .child(`${sPhoto}`)
            .getDownloadURL()
            .then(fireBaseUrl => {
              let dataArray = {
                src: fireBaseUrl,
              };
              setPicturElem(picturElem => [...picturElem, dataArray]);
              setimgViews(fireBaseUrl, uid, index, picturElem, true).then(res => {
                // handleOpenTrophieModal()
                if (!trophie) {
                  handleOpenTrophieModal()
                }
              });
              hideLoading()

            });
        }
      );
    } else {
      hideLoading()
    }
  };

  const handleUpload = () => {
      if (picturElem.length && picturElem.length > 0) {
        // if (alreadyRewarded) {
        //   setFeedbackMessage({
        //     open: true,
        //     message: 'Tus cambios se han guardado con éxito',
        //     variant: 'success',
        //   });
        // }
        if (picturElem.length !== 1) {
          setFeedbackMessage({
            open: true,
            message: 'Tus cambios se han guardado con éxito',
            variant: 'success',
          });
        }
      }
  };

  const handleDelete = (idImage, arr, pathImgItem, itemObj) => {
    let boolValues
    if (arr.length === 1 || arr.length === 0) {
        boolValues = false
        setAlreadyRewarded(false)
    } else {
      boolValues = true
    }

    let newPicturElem = picturElem.filter(function (item, index) {
      return index !== idImage;
    });

    setPicturElem(newPicturElem);
    deleteimgViews(newPicturElem, uid, idImage, arr, pathImgItem, itemObj, boolValues); 
  };

  const handleModal = image => {
    setModalImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSetImageView = () => {
    let newItem = [];

    if (imgViews && imgViews) {
      imgViews.map((elem, index) => {
        if (elem.src) {
          newItem.push({
            src: elem.src,
          });
        }
      });
      setPicturElem(newItem);
    }
  }

  useEffect(() => {
    handleSetImageView()
  }, []);

  let trophie
  if (picturElem.length > 0) {
    trophie = true
  } else {
    trophie = false
  }
  
  return (
    <>
      <div className={'picture'}>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={open}
          onClose={handleClose}
          className={classes.modal}
        >
          <div className="paper">
            <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
              <CloseIcon />
            </IconButton>
            <div className="img-container" style={{ backgroundImage: `url(${modal_image})` }}></div>
            {/* <img src={modal_image} /> */}
          </div>

        </Modal>

        <CardProfile
          title={'Fotografías'}
          subTitle={authClient && authClient.role === 'lawFirm' ?
            `Puedes colocar una galería de ${membershipLimit} fotografías de servicios o instalaciones del despacho.` :
            `Puedes colocar una galería de ${membershipLimit} fotografías para tu perfil.`
          }
          status={authClient && authClient.awardAditional.pictures ? authClient.awardAditional.pictures : false}
          awardIcon
        >
          <div className="PictureProfile">

            {picturElem && picturElem.length === 0
              ? ''
              : picturElem.map((item, index, arr) => (
                <div key={index} className="Picture-1">
                 
                  <img
                    src={item.src}
                    alt=""
                    onClick={() => {
                      handleModal(item.src);
                    }}
                    className={classes.photos}
                  />

                  {trash ? (
                    <div className="AddPicture">
                      <img
                        src="/img/profile/trash.svg"
                        onClick={() => {
                          handleDelete(index, arr, item.src, item);
                          setFeedbackMessage({
                            open: true,
                            message: 'Imagen eliminada',
                            variant: 'success',
                          });
                          setTimeout(() => {
                            handleCloseFeedbackMessage();
                          }, 3000);
                        }}
                        alt="borrar"
                      />
                    </div>
                  ) : (
                      ''
                    )}
                </div>
              ))}

            <div 
              className={picturElem.length >= membershipLimit ?
                "container-full" :
                "Picture-1"
              }
            >
              <input
                type="file"
                accept=".jpg, .jpeg, .png"
                onChange={handleChange}
                className={classes.inputFile}
                id="add_photo"
              />
              
              <label htmlFor="add_photo">
                <div
                  className={
                    picturElem.length >= membershipLimit
                      ? 'container-add container-full'
                      : 'container-add'
                  }
                >
                  <img
                    className="insertar-foto"
                    src="/img/profile/insertar-foto.svg"
                    alt=""
                  />
                </div>
              </label>
            </div>
          </div>

          <div className="horizontal-layout" style={{ marginTop: 24 }}>
            <ButtonBase
              type="button"
              onClick={handleUpload}
              variant="primary"
              classes={{ root: classes.ButtonBase }}
            >
              Guardar cambios
            </ButtonBase>
          </div>
        </CardProfile>

        <TrophieModal
          open={openTrophieModal}
          trophieValidation={trophie}
          topic="award-profile"
          handleClose={handleCloseTrophieModal}
          title="Fotografías"
          subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
          footer='Las fotografías de tus servicios o instalaciones brindan a los clientes más seguridad al contratar tus servicios'
        />

        <Snackbar
          open={feedbackMessage.open}
          message={feedbackMessage.message}
          variant={feedbackMessage.variant}
          handleClose={handleCloseFeedbackMessage}
          vertical="top"
          horizontal="right"
          snackbarTop={isMobile ? '70px' : '80px'}
        />
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  authClient: state.authClient,
  imgViews: state.authClient.imgViews,
  membershipType: state.authClient.membership.type,
  trophiePic: state.authClient.awardAditional.pictures
});

const mapDispatchToProps = dispatch => ({
  setimgViews: (item, uid, index, arr, boolValues) =>
    dispatch(setimgViews(item, uid, index, arr, boolValues)),
  deleteimgViews: (item, uid, index, arr, pathImgItem, itemObj, boolValues) =>
    dispatch(deleteimgViews(item, uid, index, arr ,pathImgItem, itemObj, boolValues)),  
  openModalFree: (open, typeMembership, role ) =>
    dispatch(openModalFree(open, typeMembership, role)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Picture);
